import { render, staticRenderFns } from "./StockInventorySurplus.vue?vue&type=template&id=1f404cdf&"
import script from "./StockInventorySurplus.vue?vue&type=script&lang=js&"
export * from "./StockInventorySurplus.vue?vue&type=script&lang=js&"
import style0 from "./StockInventorySurplus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTh,QTr,QTd,QBtn,QTooltip,QCardSection,QBadge} from 'quasar'
component.options.components = Object.assign({QTable,QTh,QTr,QTd,QBtn,QTooltip,QCardSection,QBadge}, component.options.components || {})
